<h2 mat-dialog-title>Approve Recording</h2>
<mat-dialog-content class="dialog-content">
  <p class="dialog-intro">Assign at least one product type to approve this recording for use in campaigns.</p>

  <div class="recording-name-block">
    <span class="field-label">Recording name</span>
    <p class="recording-name-value">{{ recordingName }}</p>
  </div>

  <div class="product-type-field" [class.has-error]="productTypeError">
    <app-product-type-selector
      label="Assign Product Types *"
      [panelMode]="true"
      [showInlineLoadingBar]="false"
      (selectionChange)="onProductTypesChange($event)">
    </app-product-type-selector>
    @if (productTypeError) {
      <p class="field-error" role="alert">{{ productTypeError }}</p>
    }
  </div>

  @if (submitError) {
    <p class="submit-error" role="alert">{{ submitError }}</p>
  }
</mat-dialog-content>
<mat-dialog-actions align="end" class="dialog-actions">
  <button mat-button type="button" mat-dialog-close [disabled]="sending">Cancel</button>
  <button
    mat-raised-button
    color="primary"
    type="button"
    class="approve-submit-btn"
    (click)="submit()"
    [disabled]="selectedProductTypeIds.length === 0 || sending">
    <span class="approve-submit-btn__content">
      @if (sending) {
        <mat-spinner diameter="20" class="approve-submit-spinner" />
        <span>Approving…</span>
      } @else {
        <span>Approve</span>
      }
    </span>
  </button>
</mat-dialog-actions>
